<!--
Copyright 2022 Carnegie Mellon University. All Rights Reserved.
Released under a MIT (SEI)-style license, please see LICENSE.md in the
project root for license information or contact permission@sei.cmu.edu for full terms.
-->
<div mat-dialog-container>
  <div mat-dialog-title>
    @if (data.isNew) {
    <span>Create Event</span>
    }
    @if (!data.isNew) {
    <span>Edit Event</span>
    }
    <button mat-icon-button (click)="handleEditComplete(false)" title="Cancel" class="close-button" tabindex="-1">
      <mat-icon class="mdi-24px self-center" fontIcon="mdi-close-circle-outline"></mat-icon>
    </button>
  </div>
  @if (!!data && data.scenarioEvent) {
  <div mat-dialog-content>
    <div class="scenario-event-edit-dialog">
      <!-- Scenario Event Type -->
      @if (!data.isEditingRestricted) {
      <div class="single-edit-dialog">
        <mat-form-field>
          <mat-label>Scenario Event Type</mat-label>
          <mat-select placeholder="Scenario Event Type" [(ngModel)]="data.scenarioEvent.scenarioEventType"
            (valueChange)="scenarioEventTypeChange()" [disabled]="!data.isContentDeveloper && !data.isOwner">
            @for (eventType of eventTypes; track eventType) {
            <mat-option value="{{ eventType }}">{{ eventType }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
      <!-- Integration Target -->
      @if (data.integrationTargetOptions.length > 0 && data.scenarioEvent.scenarioEventType === eventType.Inject) {
      <div class="single-edit-dialog">
        <mat-form-field class="full-width">
          <mat-label>Integration Target</mat-label>
          <mat-select multiple placeholder="Integration Target" (click)="$event.stopPropagation()"
            [value]="getIntegrationTargetArray()" (valueChange)="onIntegrationTargetChange($event)"
            [disabled]="!(data.isEditor && (!data.isEditingRestricted || data.scenarioEvent.scenarioEventType === eventType.Information))">
            @for (opt of data.integrationTargetOptions; track opt) {
            <mat-option [value]="opt">{{ opt }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
      }
      }
      <!-- Tabs -->
      <span class="single-edit-dialog">
        @if ((showDefaultTab() || data.useGallery || data.useSteamfitter) && data.scenarioEvent.scenarioEventType ===
        eventType.Inject) {
        <mat-tab-group mat-stretch-tabs class="full-width" mat-align-tabs="start" [selectedIndex]="selectedTab"
          (selectedTabChange)="tabChange($event)" style="margin-bottom: 20px;">
          @if (showDefaultTab()) {
          <mat-tab label="Default">
          </mat-tab>
          }
          <mat-tab label="All">
          </mat-tab>
          @if (data.useGallery && data.scenarioEvent.integrationTarget?.includes(integrationTarget.Gallery)) {
          <mat-tab label="Gallery Article">
          </mat-tab>
          }
          @if (data.useSteamfitter && data.scenarioEvent.integrationTarget?.includes(integrationTarget.Steamfitter)) {
          <mat-tab label="Steamfitter Task">
            <app-steamfitter-task [scenarioEvent]="data.scenarioEvent" [canEdit]="data.isEditor"></app-steamfitter-task>
          </mat-tab>
          }
        </mat-tab-group>
        }
        @if (selectedTabName !== 'Steamfitter Task') {
        <span>
          <!-- event start time (deltaSeconds) -->
          @if ((currentFilterBy === 'all' || data.scenarioEvent.scenarioEventType !== eventType.Inject) &&
          getScenarioTypeDataFields().length > 0) {
          <div class="start-time-div">
            <app-duration-edit [startTime]="data.mselStartTime" [(durationSeconds)]="data.scenarioEvent.deltaSeconds"
              [timeName]="'Execution Date / Time'" [postScript]="''" [canEdit]="data.isEditor">
            </app-duration-edit>
          </div>
          }
          <!-- data values for each data field -->
          @for (df of getScenarioTypeDataFields(); track df) {
          <div class="full-width">
            <app-data-value [(value)]="getDataValue(df.name).value" [dataField]="df"
              [canEdit]="data.isEditor && (!data.isEditingRestricted || data.scenarioEvent.scenarioEventType === eventType.Information)"
              [canApprove]="data.isApprover" [isOwner]="data.isOwner" [showValueOnly]="false"
              [organizationOptions]="data.organizationList" [teamOptions]="data.teamList" [unitOptions]="data.unitList"
              [cardOptions]="data.cardList" [moveOptions]="data.moveList"
              [gallerySourceTypeOptions]="data.gallerySourceTypes" [userOptions]="data.userList"></app-data-value>
          </div>
          }
          <!-- metadata-->
          @if (currentFilterBy === 'all' && data.scenarioEvent.scenarioEventType === eventType.Inject) {
          <div class="full-width">
            <mat-form-field class="full-width">
              <mat-label>Row Metadata</mat-label>
              <input type="text" matInput placeholder="row metadata" [(ngModel)]="data.scenarioEvent.rowMetadata"
                [disabled]="!data.isEditor" />
            </mat-form-field>
          </div>
          }
          <!-- no data fields message -->
          @if (getScenarioTypeDataFields().length === 0) {
          <div class="full-width">
            <br /><br />
            <b>No data fields have been defined for this scenario event type!</b>
          </div>
          }
        </span>
        }
      </span>
    </div>
  </div>
  }
  <div mat-dialog-actions>
    <button mat-stroked-button (click)="handleEditComplete(true)"
      [disabled]="hasBadData() || !data.isEditor">Save</button>
    <button mat-stroked-button (click)="handleEditComplete(false)">Cancel</button>
  </div>
</div>
